
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class RadiationScanEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(40 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.4 / layerIndex;
            for (let i = 0; i < count; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 3;
                const ry = (this.pseudoRandom(i + 1) - 0.5) * height * 3;
                
                const pingTime = (curTime + this.pseudoRandom(i) * 5) % 2;
                if (pingTime < 0.5) {
                    const alpha = 1 - (pingTime / 0.5);
                    ctx.globalAlpha = alpha;
                    ctx.beginPath();
                    ctx.arc(rx, ry, (2 + pingTime * 20) * scale, 0, Math.PI * 2);
                    ctx.fill();
                }
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
